import './keyValueField.scss'
import templateUrl from './keyValueField.html'

/**
 * Key-Value form field component.
 *
 * @example
 * <tmr-key-value-field
 *   values=""
 *   on-add=""
 *   on-remove=""
 * ></tmr-key-value-field>
 *
 * @type {ngComponent}
 * @prop {array} values
 * @prop {function} on-add
 * @prop {function} on-remove
 */
export const tmrKeyValueField = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrKeyValueFieldController',
  bindings: {
    values: '<',
    onAdd: '&',
    onRemove: '&',
  },
}

/**
 * Controller of component {@link tmrKeyValueField}.
 *
 * @type {ngController}
 */
export class tmrKeyValueFieldController {
  static ngType = 'controller'

  constructor($scope) {
    'ngInject'
    Object.assign(this, { $scope })
  }

  add(key, value) {
    this.onAdd({ key: key, value: value })
    this.key = ''
    this.value = ''
    this.focusKey = true
  }

  keypress($event) {
    if (
      $event.which === 13 &&
      this.$scope.keyValue.$valid &&
      this.key &&
      this.value
    ) {
      this.add(this.key, this.value)
    }
  }
}
